import { render, staticRenderFns } from "./view-tag.vue?vue&type=template&id=03a5f68c&scoped=true&"
import script from "./view-tag.vue?vue&type=script&lang=ts&"
export * from "./view-tag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a5f68c",
  null
  
)

export default component.exports